import * as React from 'react';

import SocialShareCardNotConfigurable from 'bundles/page-config-common/components/enterprise/SocialShareCardNotConfigurable';
import HomeSection from 'bundles/page-config-common/components/shared/HomeSection';

const SocialShareCardModuleRenderer = () => {
  return (
    <HomeSection className="PageConfig_EnterpriseSocialShareCard">
      <SocialShareCardNotConfigurable />
    </HomeSection>
  );
};

export default SocialShareCardModuleRenderer;
